module.exports = "<span *ngIf=\"loadStore\">\n    <packages-list *ngIf=\"displayConfig.packages.enable\"></packages-list>\n</span>\n"